import React, { useState } from "react"
import "./Availability.css"

import MyCalendar from "./toast.ui.js"
import Modal from "../../Components/Modal/Modal"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import { connect } from "react-redux"
import TeacherPageContainer from "../Container/TeacherPageContainer"
import { updateAvailability } from "../../redux/homePage/homePage.actions"
import { useLocation, useHistory } from "react-router-dom";

const Moment = require("moment")
const MomentRange = require("moment-range")
const moment = MomentRange.extendMoment(Moment)

// import DatePicker from "../User/DateRange";

const Availability = (props) => {
  // const [browser_width, setBrowser_width] = useState();
  const [from_date, setFDate] = useState(new Date())
  const [to_date, setToDate] = useState(new Date())
  const history = useHistory()
  // const [user, setUser] = useState(
  // 	JSON.parse(window.localStorage.getItem("user"))
  // );
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isSelect = (time, date) => {
    let newdate = moment(date).format("YYYY-MM-DD")
    const userData = props.user
    let flag = false
    if (userData.rules[0]) {
      if (userData.rules[0][newdate] && userData.rules[0][newdate].time) {
        console.log(
          userData.rules[0][newdate].time +
          "---------" +
          time +
          "-----------" +
          newdate
        )
        console.log(userData.rules[0][newdate].time.includes(time))
        flag = userData.rules[0][newdate].time.includes(time)
        return flag
      }
    }
    return flag
  }

  const tabs = [
    {
      text: "My Calendar",
      pathname: "/MyCalendar",
      active: true
    },
    {
      text: "Job List",
      pathname: "/TeacherJobList"
    }
  ]

  return (
    <TeacherPageContainer
      header="My Calendar"
      tabs={tabs}
    >
      <Modal
        className="confirm-delete"
        header="Calendar Sent"
        show={!!searchParams.get("isSendedCalendar")}
        onClose={() => history.push("/myCalendar")}
      />
      {/* <div className="calendar-instruct">
        Click on any present or future date to set availability. See Job List for information on all bookings.
      </div> */}
      <MyCalendar
        user={props.user}
        isRequestView={searchParams.get("request_view_id")}
        isSelect={isSelect}
        updateAvailability={props.updateAvailability}
        useDetailPopup={true}
      ></MyCalendar>
    </TeacherPageContainer>
  )
}

function mapStateToProps(state) {
  return { user: state.user.user }
}

const mapDispatchToProps = (dispatch) => ({
  updateAvailability: (user) => dispatch(updateAvailability(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Availability)
